import { useEffect, useState } from "react";
import api, { apiError } from "../../lib/api";
import { toast } from "sonner";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api
      .get("/admin/customers")
      .then((r) => setList(r.data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  const filtered = list.filter((c) =>
    !q ||
    c.email?.toLowerCase().includes(q.toLowerCase()) ||
    `${c.first_name} ${c.last_name}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="p-6 md:p-10" data-testid="admin-customers">
      <header className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 gap-4">
        <div>
          <span className="font-script text-3xl text-blush-400">the people</span>
          <h1 className="font-heading text-3xl md:text-4xl text-ink-900">Customers</h1>
        </div>
        <input
          className="field md:max-w-sm"
          placeholder="Search by name or email…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </header>

      <div className="rounded-3xl bg-white border border-blush-100 overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full text-sm font-body min-w-[640px]">
          <thead>
            <tr className="bg-blush-50/40 text-left text-[11px] uppercase tracking-[0.18em] text-ink-500">
              <th className="px-6 py-3">Name</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">City</th>
              <th className="px-6 py-3">Orders</th>
              <th className="px-6 py-3">Spent</th>
              <th className="px-6 py-3">Joined</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="px-6 py-10 text-center text-ink-500">Loading…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={6} className="px-6 py-10 text-center text-ink-500">
                {list.length === 0 ? "No customers yet." : "No matches."}
              </td></tr>
            ) : filtered.map((c) => (
              <tr key={c.id} className="border-t border-blush-100 hover:bg-blush-50/40">
                <td className="px-6 py-3 text-ink-900">{c.first_name} {c.last_name}</td>
                <td className="px-6 py-3 text-ink-700">{c.email}</td>
                <td className="px-6 py-3 text-ink-700">{c.city || "—"}</td>
                <td className="px-6 py-3">{c.orders_count || 0}</td>
                <td className="px-6 py-3 text-ink-900">₹{(c.total_spent || 0).toLocaleString("en-IN")}</td>
                <td className="px-6 py-3 text-xs text-ink-500">{(c.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
